import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/Service/auth.service';
import { LoadingService } from 'src/app/Service/loading.service';
import { UserService } from 'src/app/User/Service/user.service';
import { GlobalConstants } from 'src/app/utils/global-constants';
import { ProfessionalService } from '../../professional.service';
import { NavigationExtras, Router } from '@angular/router';
import { NotificationService } from 'src/app/Service/notification.service';

enum SecurityTab {
  SecurityFirst = 0,
  EaseOfUse = 1,
  RealSupport = 2
}

@Component({
    selector: 'app-professional-landingpage',
    templateUrl: './professional-landingpage.component.html',
    styleUrls: ['./professional-landingpage.component.css'],
    standalone: false
})
export class ProfessionalLandingpageComponent {
  email: any;
  emailForm: FormGroup;
  @ViewChild('professionpopup') professionpopup;
  @ViewChild('inviteprofessional') inviteprofessional;
  loginform = new FormGroup({
    Recipientname : new FormControl('',[Validators.required,Validators.pattern(GlobalConstants.firstnamePattern)]),
    Recipientemail : new FormControl('',[Validators.required,Validators.pattern(GlobalConstants.emailPattern)]),
    Sendersname : new FormControl('',[Validators.required,Validators.pattern(GlobalConstants.firstnamePattern)]),
    Sendersemail : new FormControl('',[Validators.required,Validators.pattern(GlobalConstants.emailPattern)]),
    suggestions: new FormControl('',Validators.required),
    invite: new FormControl('',Validators.required),
  })

  get Recipientname(){
      return this.loginform.get('Recipientname');
  }
  get Recipientemail(){
      return this.loginform.get('Recipientemail');
  }
  get Sendersname(){
    return this.loginform.get('Sendersname');
  }
  get Sendersemail(){
    return this.loginform.get('Sendersemail');
  }
  
  @ViewChild('pricing') pricing;
  @ViewChild('aboutUsPopUp') aboutUsPopUp;
  @ViewChild('inviteModal') inviteModal;

  public securityType: any;
  currentSecurityType: any;
  currentLogoInfo: any;
  formdata : any;

  constructor(
    public auth: AuthService,
    public userService: UserService,
    private loader: LoadingService,
    private modalService: NgbModal,
    private professionalService: ProfessionalService,
    private router: Router,   
    public notify: NotificationService,
    private formBuilder: FormBuilder
  ) {
    this.securityType = SecurityTab;
    this.currentSecurityType = this.securityType.SecurityFirst;
  }
  ngOnInit(): void {
    this.loader.HideLoading();
    this.emailForm = this.formBuilder.group({
      email: [
        '',
        [Validators.required, Validators.pattern(GlobalConstants.emailPattern)],
      ],
    });
  }

  showPricing() {
    this.modalService.open(this.pricing, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
  }

  inviteProfessionalPopup(){
    this.modalService.open(this.inviteModal, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
  }

  onClose() {
    this.modalService.dismissAll();
  }

  showaboutUsPopUp(teamMember) {
    this.currentLogoInfo = teamMember;
    this.modalService.open(this.aboutUsPopUp, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
  }

  signUpProfessional(){
    this.router.navigate(['/professional/signup']);
  }
  goToSignUp(){
    if(this.emailForm.valid){
    const navigationExtras: NavigationExtras = {
      state: {
        email: this.emailForm.get('email').value,
      },
    };
    this.router.navigateByUrl('/professional/signup', navigationExtras);
  }else{
    this.emailForm.markAllAsTouched();
  }
  }

  Logoinfo=[
    {
      image:"/assets/images/sectigo.webp",
      name:"SECTIGO",
      description:"Sectigo is a leading cybersecurity provider of digital identity solutions, including TLS /"+
      "SSL certificates, DevOps, IoT, and enterprise-grade PKI management, as well as multi-layered"+
      "web security. As the world's largest commercial Certificate Authority with more than 700,000"+
      "customers and over 20 years of experience in online trust, Sectigo partners with"+
      "organizations of all sizes to deliver automated public and private PKI solutions for"+
      "securing webservers, user access, connected devices, and applications. Recognized for its"+
      "award-winning innovation and best-in-class global customer support, Sectigo has the proven"+
      "performance needed to secure the digital landscape of today and tomorrow."
    },
    {
      image:"/assets/images/wowrack.webp",
      name:"WOWRACK",
      description:"Wowrack (Wow Technologies, Inc.) is a multinational IT company that provides various cloud infrastructure, backup and disaster recovery, colocation, and cybersecurity solutions. Wow Technologies, Inc. is a leader in managed hosting, providing various hosting services that is scalable, flexible, and cost effective. Wowrack also provides a full range of customizable services that best fit client’s growing needs."
    },
    {
      image:"/assets/images/arctic-wolf.webp",
      name:"ARCTIC WOLF",
      description:"Arctic Wolf is the market leader in Security Operations, helping organizations end cyber risk by providing security operations as a concierge service. Arctic Wolf solutions include Managed Detection and Response (MDR), Managed Risk, Managed Cloud Monitoring, and Managed Security Awareness; each delivered by the industry’s original Concierge Security® Team. Highly trained Concierge Security experts work as an extension of internal teams to provide 24×7 monitoring, detection, and response, as well as ongoing risk management to proactively protect organizations while continually strengthening the security posture. "
    },
  ]
}
